import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu--companies-index--search-result-header', class extends Controller {
  static targets = ['orderSelect']

  static values = {
    defaultSortKey: String
  }

  onOrderChange(event) {
    const select = event.target
    const selectedValue = select.value

    // デフォルトのソートキーが選択された場合はorderパラメータを削除
    if (selectedValue === this.defaultSortKeyValue) {
      select.disabled = true
    }

    this.element.submit()
  }
})
